import { render, staticRenderFns } from "./child-form.vue?vue&type=template&id=95875004&lang=pug&"
import script from "./child-form.vue?vue&type=script&lang=js&"
export * from "./child-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports